import { createFileRoute } from '@tanstack/react-router'
import ContactWorks from 'Contact/components/Contact/Sections/ContactWorks'

export const Route = createFileRoute('/contact/$contactId/works')({
    component: ContactWorks,
})
